<div class="full-height-flex">
  <div class="step-sub-heading-with-actions">
    <div class='step-content-header'>@if (titleIcon) {
      <mat-icon class='title'>{{titleIcon}}</mat-icon>
    }{{node.details.label}}</div>
  </div>
  <div class="remaining-space-flex-content-wrapper">
    <div class="remaining-space-flex-content">
      <div class='step-content-card item-details full-height' [ngClass]='boxShadowClass'>
        <p>
          <adm4-detail-message
            [node]='node'
            [outputType]='outputType'
            [pattern]='pattern'
            [projectKey]='projectKey'>
          </adm4-detail-message>
        </p>
        <p>
          <strong>Command</strong>
        </p>
        <p>{{node.details.command}}</p>
        @if (shouldDisplayConditions) {
          <p>
            <strong>Command triggers</strong>
          </p>
          <p>
            Depending on the outcome of this check, the following commands will be run:
          </p>
          <ul>
            @for (command of conditionFailureCommands; track command) {
              <li>
                <span>If the check fails: </span><span class='link-button' (click)='navigateToCommand(command.commandId)'>{{command.label}}</span>
              </li>
            }
            @for (command of conditionSuccessCommands; track command) {
              <li>
                <span>If the check succeeds: </span><span class='link-button' (click)='navigateToCommand(command.commandId)'>{{command.label}}</span>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>
</div>